var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    height: 21,
    width: 21,
    id: "svg4696",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4700"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title4688"
  }, "airport.svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title4688"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 38,
    width: 21,
    height: 21,
    id: "rect4690",
    style: {
      fill: "none",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21,
    height: 21,
    rx: 10.5,
    ry: 10.5,
    fill: "#ffffff",
    id: "rect4692",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g26786-3",
    transform: "matrix(1.7623702,0,0,1.4399942,3.0972534,-1.7544357)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.052
    },
    id: "path6066-4-6",
    d: "M 29.334951,7.4375911 21.020892,7.3697495 25.236674,0.20348412 Z",
    transform: "matrix(0.65294821,-0.01122446,0.00497691,1.386872,-11.603478,3.8032821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect5961-9-0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.0573499
    },
    d: "M 2.1585677,3.7890398 V 13.78904 H 4.8414285 V 3.7890398 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.052
    },
    id: "path6066",
    d: "M 29.334951,7.4375911 21.020892,7.3697495 25.236674,0.20348412 Z",
    transform: "matrix(0.9862203,-0.00786752,0.00751718,0.97209556,-30.552201,-18.340924)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.0414283
    },
    id: "rect5961",
    width: 7,
    height: 7,
    x: -12.667606,
    y: -18.341503,
    ry: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "g26786",
    transform: "matrix(1,0,0,1.1999952,-31.698003,19.68118)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.052
    },
    id: "path6066-4",
    d: "M 29.334951,7.4375911 21.020892,7.3697495 25.236674,0.20348412 Z",
    transform: "matrix(0.65294821,-0.01122446,0.00497691,1.386872,-11.603478,3.8032821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect5961-9",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.0573499
    },
    d: "M 2.1585677,3.7890398 V 13.78904 H 4.8414285 V 3.7890398 Z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.052
    },
    id: "path6066-4-3",
    d: "M 29.334951,7.4375911 21.020892,7.3697495 25.236674,0.20348412 Z",
    transform: "matrix(0.58424414,-0.01123932,0.00445323,1.3887079,-45.707329,-1.5124648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect5961-9-17",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.054867
    },
    d: "m -33.423178,-1.5134878 v 10 h 2.455587 v -10 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.052
    },
    id: "path6097",
    d: "M 29.334951,7.4375911 21.020892,7.3697495 25.236674,0.20348412 Z",
    transform: "matrix(0.9862203,-0.00786752,0.00751718,0.97209556,-37.552201,-18.340924)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M -58,9.8182 V 11.5 l -6.5,-1 -0.3182,4.7727 L -62,17 v 1 L -65.5,17.3182 -69,18 V 17 L -66.1818,15.2727 -66.5,10.5 -73,11.5 V 9.8182 L -66.5,7.5 v -3 c 0,0 0,-1.5 1,-1.5 1,0 1,1.5 1,1.5 v 2.8182 z",
    id: "path4694",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-2",
    style: {
      fill: "#000000",
      strokeWidth: 1.12078
    },
    d: "m -2.9926042,-17.508171 a 1.75,0.7 0 0 1 -1.75,0.699219 v 0.467448 a 2.25,1.1666665 0 0 0 2.25,-1.166667 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0",
    style: {
      fill: "#000000",
      strokeWidth: 1.12078
    },
    d: "m -2.9926042,-17.508171 a 2.25,1.1666665 0 0 0 2.25,1.166667 2.25,1.1666665 0 0 0 2.25,-1.166667 h -0.5 a 1.75,0.7 0 0 1 -1.75,0.699219 1.75,0.7 0 0 1 -1.75,-0.699219 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-6",
    style: {
      fill: "#000000",
      strokeWidth: 1.12078
    },
    d: "m 1.0073958,-17.508171 a 2.25,1.1666665 0 0 0 2.25,1.166667 v -0.467448 a 1.75,0.7 0 0 1 -1.75,-0.699219 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-0-4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.12078
    },
    d: "m -2.9926042,-17.941504 a 1.75,0.7 0 0 1 -1.75,0.699218 v 0.467448 a 2.25,1.1666665 0 0 0 2.25,-1.166666 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.12078
    },
    d: "m -2.9926042,-17.941504 a 2.25,1.1666665 0 0 0 2.25,1.166666 2.25,1.1666665 0 0 0 2.25,-1.166666 h -0.5 a 1.75,0.7 0 0 1 -1.75,0.699218 1.75,0.7 0 0 1 -1.75,-0.699218 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-3-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.12078
    },
    d: "m 1.0073958,-17.941504 a 2.25,1.1666665 0 0 0 2.25,1.166666 v -0.467448 a 1.75,0.7 0 0 1 -1.75,-0.699218 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-2-7",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -39.574448,32.088693 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0-4",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -39.574448,32.088693 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-6-5",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -35.574448,32.088693 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-0-4-2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -39.574448,31.438693 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7-5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -39.574448,31.438693 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-3-6-4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -35.574448,31.438693 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-2-7-5",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 36.753057,13.024183 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0-4-0",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 36.753057,13.024183 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0-4-0-7",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 40.753057,13.024183 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-6-5-4",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 44.753057,13.024183 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-0-4-2-8",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 36.753199,12.324183 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7-5-7",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 36.753057,12.324183 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7-5-7-2",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 40.753057,12.324183 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-3-6-4-1",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 44.753057,12.324183 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-2-7-5-7",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 31.072243,8.9469902 a 1.75,1.05 0 0 1 -1.75,1.048828 V 10.69699 a 2.25,1.75 0 0 0 2.25,-1.7499998 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0-4-0-2",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 31.072243,8.9469902 a 2.25,1.75 0 0 0 2.25,1.7499998 2.25,1.75 0 0 0 2.25,-1.7499998 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0-4-0-7-2",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 35.072243,8.9469902 a 2.25,1.75 0 0 0 2.25,1.7499998 2.25,1.75 0 0 0 2.25,-1.7499998 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-6-5-4-6",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 39.072243,8.9469902 a 2.25,1.75 0 0 0 2.25,1.7499998 V 9.9958182 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-0-4-2-8-1",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 31.168385,8.2469902 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7-5-7-0",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 31.168243,8.2469902 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7-5-7-2-6",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 35.168243,8.2469902 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-3-6-4-1-1",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 39.168243,8.2469902 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-2-7-5-5",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 30.572243,5.6469902 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0-4-0-9",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 30.572243,5.6469902 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0-4-0-7-4",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 34.572243,5.6469902 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-6-5-4-9",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 38.572243,5.6469902 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-0-4-2-8-0",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 30.572243,4.9469902 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7-5-7-9",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 30.572101,4.9469902 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7-5-7-2-1",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 34.572101,4.9469902 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-3-6-4-1-7",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 38.572101,4.9469902 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-2-7-5-5-9",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 30.072243,2.4430223 a 1.75,1.05 0 0 1 -1.75,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0-4-0-9-7",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 30.072243,2.4430223 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0-4-0-7-4-7",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 34.072243,2.4430223 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-6-5-4-9-6",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 38.072243,2.4430223 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-0-4-2-8-0-7",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 30.072385,1.7430222 a 1.75,1.05 0 0 1 -1.75,1.0488281 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.7500001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7-5-7-9-3",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 30.072243,1.7430222 a 2.25,1.75 0 0 0 2.25,1.7500001 2.25,1.75 0 0 0 2.25,-1.7500001 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.0488281 1.75,1.05 0 0 1 -1.75,-1.0488281 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7-5-7-2-1-6",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 34.072243,1.7430222 a 2.25,1.75 0 0 0 2.25,1.7500001 2.25,1.75 0 0 0 2.25,-1.7500001 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.0488281 1.75,1.05 0 0 1 -1.75,-1.0488281 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-3-6-4-1-7-5",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 38.072243,1.7430222 a 2.25,1.75 0 0 0 2.25,1.7500001 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.0488281 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g17366",
    transform: "translate(0,38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-2-1",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 8.252,12.457904 a 1.75,0.90381642 0 0 1 -1.75,0.902807 v 0.603553 a 2.25,1.5063607 0 0 0 2.25,-1.50636 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-0-5",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 8.252,12.457904 a 2.25,1.5063607 0 0 0 2.25,1.50636 2.25,1.5063607 0 0 0 2.25,-1.50636 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.902807 1.75,0.90381642 0 0 1 -1.75,-0.902807 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-6-5-0",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 12.252,12.457904 a 2.25,1.5063607 0 0 0 2.25,1.50636 v -0.603553 a 1.75,0.90381642 0 0 1 -1.75,-0.902807 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-3-0-4-5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 8.252,11.898398 a 1.75,0.90381642 0 0 1 -1.75,0.902808 v 0.603553 a 2.25,1.5063607 0 0 0 2.25,-1.506361 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-6-6-7-6",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 8.252,11.898398 a 2.25,1.5063607 0 0 0 2.25,1.506361 2.25,1.5063607 0 0 0 2.25,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.902808 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-1-3-6-9",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 12.252,11.898398 a 2.25,1.5063607 0 0 0 2.25,1.506361 v -0.603553 a 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g17388",
    transform: "translate(0,38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 4.233235,15.946608 a 1.75,0.90381642 0 0 1 -1.75,0.902808 v 0.603553 a 2.25,1.5063607 0 0 0 2.25,-1.506361 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 8.233235,15.946608 a 2.25,1.5063607 0 0 0 2.250001,1.506361 2.25,1.5063607 0 0 0 2.249999,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.749999,0.902808 1.75,0.90381642 0 0 1 -1.750001,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 4.233235,15.946608 a 2.25,1.5063607 0 0 0 2.250001,1.506361 2.25,1.5063607 0 0 0 2.25,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.902808 1.75,0.90381642 0 0 1 -1.750001,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 12.232909,15.946608 a 2.25,1.5063607 0 0 0 2.25,1.506361 2.25,1.5063607 0 0 0 2.25,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.902808 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 16.232909,15.946608 a 2.25,1.5063607 0 0 0 2.25,1.506361 v -0.603553 a 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 4.23,15.443934 a 1.75,0.90381642 0 0 1 -1.75,0.902808 v 0.603553 a 2.25,1.5063607 0 0 0 2.25,-1.506361 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "M 8.23,15.443934 A 2.25,1.5063607 0 0 0 10.480001,16.950295 2.25,1.5063607 0 0 0 12.73,15.443934 h -0.5 A 1.75,0.90381642 0 0 1 10.480001,16.346742 1.75,0.90381642 0 0 1 8.73,15.443934 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 4.23,15.443934 a 2.25,1.5063607 0 0 0 2.250001,1.506361 2.25,1.5063607 0 0 0 2.25,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.902808 A 1.75,0.90381642 0 0 1 4.73,15.443934 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 12.229675,15.443934 a 2.25,1.5063607 0 0 0 2.25,1.506361 2.25,1.5063607 0 0 0 2.249999,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.902808 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 16.229674,15.443934 a 2.25,1.5063607 0 0 0 2.25,1.506361 v -0.603553 a 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g17388-88",
    transform: "matrix(1,0,0,1.4160853,-31.797005,6.9350334)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-9",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 8.233235,15.946608 a 2.25,1.5063607 0 0 0 2.250001,1.506361 2.25,1.5063607 0 0 0 2.249999,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.749999,0.902808 1.75,0.90381642 0 0 1 -1.750001,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-7",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 7.0450938,17.404871 a 2.25,1.5063607 0 0 0 1.6874999,-1.458984 h -0.5 a 1.75,0.90381642 0 0 1 -1.3164062,0.873047 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-7",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 12.232909,15.946608 a 2.25,1.5063607 0 0 0 2.25,1.506361 2.25,1.5063607 0 0 0 2.25,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.902808 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-64",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 16.232909,15.946608 a 2.25,1.5063607 0 0 0 2.25,1.506361 v -0.603553 a 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-8-0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "M 8.23,15.443934 A 2.25,1.5063607 0 0 0 10.480001,16.950295 2.25,1.5063607 0 0 0 12.73,15.443934 h -0.5 A 1.75,0.90381642 0 0 1 10.480001,16.346742 1.75,0.90381642 0 0 1 8.73,15.443934 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-4-30",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 6.9376719,16.918543 a 2.25,1.5063607 0 0 0 1.7929687,-1.474609 h -0.5 A 1.75,0.90381642 0 0 1 6.8087656,16.3287 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-5-9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 12.229675,15.443934 a 2.25,1.5063607 0 0 0 2.25,1.506361 2.25,1.5063607 0 0 0 2.249999,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.902808 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-0-2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 16.229674,15.443934 a 2.25,1.5063607 0 0 0 2.25,1.506361 v -0.603553 a 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer10",
    style: {
      display: "inline"
    },
    transform: "translate(-0.201,6.443934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-8",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m -5.565765,9.502674 a 1.75,0.90381642 0 0 1 -1.75,0.902808 v 0.603553 a 2.25,1.5063607 0 0 0 2.25,-1.506361 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28173",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m -5.0644531,9.509766 a 1.75,0.90381642 0 0 1 -0.00195,-0.00781 h -0.5 a 2.25,1.5063607 0 0 0 0.3300781,0.78125 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28171",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m -5.0644531,9.509766 -0.171875,0.773437 a 2.25,1.5063607 0 0 0 1.9199219,0.726563 2.25,1.5063607 0 0 0 0.5625,-0.04883 L -2.8828125,10.375 a 1.75,0.90381642 0 0 1 -0.4335937,0.03125 1.75,0.90381642 0 0 1 -1.7480469,-0.896484 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-7-3",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m -5.77,15.443934 a 1.75,0.90381642 0 0 1 -1.75,0.902808 v 0.603553 a 2.25,1.5063607 0 0 0 2.25,-1.506361 z",
    transform: "translate(0.201,-6.443934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28134",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "M -5.0058594,9.238281 A 1.75,0.90381642 0 0 1 -5.0683594,9 h -0.5 a 2.25,1.5063607 0 0 0 0.421875,0.875 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28132",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "M -5.0058594,9.238281 -5.1464844,9.875 a 2.25,1.5063607 0 0 0 1.828125,0.630859 2.25,1.5063607 0 0 0 0.4570313,-0.03125 L -2.9902344,9.884766 a 1.75,0.90381642 0 0 1 -0.328125,0.017578 1.75,0.90381642 0 0 1 -1.6875,-0.664063 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g17388-8",
    transform: "matrix(1,0,0,1.4160853,-31.797005,10.935033)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-1",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 8.233235,15.946608 a 2.25,1.5063607 0 0 0 2.250001,1.506361 2.25,1.5063607 0 0 0 2.249999,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.749999,0.902808 1.75,0.90381642 0 0 1 -1.750001,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-8",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 7.8673594,17.133387 a 2.25,1.5063607 0 0 0 0.8652343,-1.1875 h -0.5 a 1.75,0.90381642 0 0 1 -0.4902343,0.623047 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-9",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 12.232909,15.946608 a 2.25,1.5063607 0 0 0 2.25,1.506361 2.25,1.5063607 0 0 0 2.25,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.902808 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-6",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 16.232909,15.946608 a 2.25,1.5063607 0 0 0 2.25,1.506361 v -0.603553 a 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-8-3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "M 8.23,15.443934 A 2.25,1.5063607 0 0 0 10.480001,16.950295 2.25,1.5063607 0 0 0 12.73,15.443934 h -0.5 A 1.75,0.90381642 0 0 1 10.480001,16.346742 1.75,0.90381642 0 0 1 8.73,15.443934 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-4-3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 7.76775,16.678309 a 2.25,1.5063607 0 0 0 0.9628906,-1.234375 h -0.5 A 1.75,0.90381642 0 0 1 7.64275,16.115809 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-5-38",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 12.229675,15.443934 a 2.25,1.5063607 0 0 0 2.25,1.506361 2.25,1.5063607 0 0 0 2.249999,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.902808 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-0-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 16.229674,15.443934 a 2.25,1.5063607 0 0 0 2.25,1.506361 v -0.603553 a 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer9",
    transform: "translate(-0.201,2.443934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-3",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m -5.766765,15.946608 a 1.75,0.90381642 0 0 1 -1.75,0.902808 v 0.603553 a 2.25,1.5063607 0 0 0 2.25,-1.506361 z",
    transform: "translate(0.201,-2.443934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28014",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m -1.9316406,14.689453 -0.125,-0.564453 a 1.75,0.90381642 0 0 1 -1.2597656,0.28125 1.75,0.90381642 0 0 1 -1.75,-0.904297 h -0.5 a 2.25,1.5063607 0 0 0 2.25,1.507813 2.25,1.5063607 0 0 0 1.3847656,-0.320313 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-7-4",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m -5.569,13 a 1.75,0.90381642 0 0 1 -1.75,0.902808 v 0.603553 A 2.25,1.5063607 0 0 0 -5.069,13 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27980",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m -2.03125,14.234375 -0.125,-0.5625 A 1.75,0.90381642 0 0 1 -3.3183594,13.902344 1.75,0.90381642 0 0 1 -5.0683594,13 h -0.5 a 2.25,1.5063607 0 0 0 2.25,1.505859 2.25,1.5063607 0 0 0 1.2871094,-0.271484 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g17388-5",
    transform: "matrix(1,0,0,1.4158071,-31.796854,2.9397394)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-6",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 8.233235,15.946608 a 2.25,1.5063607 0 0 0 2.250001,1.506361 2.25,1.5063607 0 0 0 2.249999,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.749999,0.902808 1.75,0.90381642 0 0 1 -1.750001,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-2",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 6.1699426,17.436121 a 2.25,1.5063607 0 0 0 0.3125,0.01758 2.25,1.5063607 0 0 0 2.25,-1.507813 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.904297 1.75,0.90381642 0 0 1 -0.4492187,-0.0332 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-1",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 12.232909,15.946608 a 2.25,1.5063607 0 0 0 2.25,1.506361 2.25,1.5063607 0 0 0 2.25,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.902808 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-7",
    style: {
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m 16.232909,15.946608 a 2.25,1.5063607 0 0 0 2.25,1.506361 v -0.603553 a 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-8-5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "M 8.23,15.443934 A 2.25,1.5063607 0 0 0 10.480001,16.950295 2.25,1.5063607 0 0 0 12.73,15.443934 h -0.5 A 1.75,0.90381642 0 0 1 10.480001,16.346742 1.75,0.90381642 0 0 1 8.73,15.443934 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-5-4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 12.229675,15.443934 a 2.25,1.5063607 0 0 0 2.25,1.506361 2.25,1.5063607 0 0 0 2.249999,-1.506361 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.902808 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-4-7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 5.9179895,16.29745 0.1386719,0.623046 a 2.25,1.5063607 0 0 0 0.4238281,0.0293 2.25,1.5063607 0 0 0 2.25,-1.505859 h -0.5 a 1.75,0.90381642 0 0 1 -1.75,0.902344 1.75,0.90381642 0 0 1 -0.5625,-0.04883 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-0-1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m 16.229674,15.443934 a 2.25,1.5063607 0 0 0 2.25,1.506361 v -0.603553 a 1.75,0.90381642 0 0 1 -1.75,-0.902808 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer8",
    transform: "translate(-0.20115111,10.443934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-9",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m -1.0383512,5.5027092 a 1.75,0.90381642 0 0 1 -1.75,0.902808 v 0.603553 a 2.25,1.5063607 0 0 0 2.24999997,-1.506361 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-7-8",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m -1.0415862,4.9998159 a 1.75,0.90381642 0 0 1 -1.75,0.902808 v 0.603553 a 2.25,1.5063607 0 0 0 2.24999997,-1.506361 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27794",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m -3.8108721,5.7806577 -0.125,0.566406 a 2.25,1.5063607 0 0 0 0.6210938,0.142578 l -0.1386719,-0.623046 a 1.75,0.90381642 0 0 1 -0.3574219,-0.085938 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27792",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.27353
    },
    d: "m -4.941039,5.0860044 a 2.25,1.5063607 0 0 0 1.205078,1.333984 l 0.125,-0.566406 a 1.75,0.90381642 0 0 1 -0.830078,-0.767578 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27758",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m -4.2439462,6.1660748 a 1.75,0.90381642 0 0 1 -0.7265625,-0.730469 h -0.5 a 2.25,1.5063607 0 0 0 1.1015625,1.292969 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27756",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.27353
    },
    d: "m -4.2439462,6.1660748 -0.125,0.5625 a 2.25,1.5063607 0 0 0 0.8359375,0.197265 l -0.1367187,-0.61914 a 1.75,0.90381642 0 0 1 -0.5742188,-0.140625 z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer6",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-6",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -28.237128,-1.3392953 a 1.75,1.05 0 0 1 -1.75,1.04882801 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75000001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-3",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -24.237128,-1.3392953 a 2.25,1.75 0 0 0 2.250001,1.75000001 2.25,1.75 0 0 0 2.249999,-1.75000001 h -0.5 a 1.75,1.05 0 0 1 -1.749999,1.04882801 1.75,1.05 0 0 1 -1.750001,-1.04882801 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-9",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -28.237128,-1.3392953 a 2.25,1.75 0 0 0 2.250001,1.75000001 2.25,1.75 0 0 0 2.25,-1.75000001 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.04882801 1.75,1.05 0 0 1 -1.750001,-1.04882801 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-4",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -20.237629,-1.3388977 a 2.25,1.75 0 0 0 2.25,1.75000001 2.25,1.75 0 0 0 0.796875,-0.1152344 v -0.7050781 a 1.75,1.05 0 0 1 -0.796875,0.1191406 1.75,1.05 0 0 1 -1.75,-1.04882811 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-8",
    style: {
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 20.343055,-8.1983221 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-7-1",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -28.240363,-1.9232727 a 1.75,1.05 0 0 1 -1.75,1.04882801 v 0.701172 a 2.25,1.75 0 0 0 2.25,-1.75000001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-8-2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -24.240363,-1.9232727 a 2.25,1.75 0 0 0 2.250001,1.75000001 2.25,1.75 0 0 0 2.249999,-1.75000001 h -0.5 a 1.75,1.05 0 0 1 -1.749999,1.04882801 1.75,1.05 0 0 1 -1.750001,-1.04882801 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-4-9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -28.240363,-1.9232727 a 2.25,1.75 0 0 0 2.250001,1.75000001 2.25,1.75 0 0 0 2.25,-1.75000001 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.04882801 1.75,1.05 0 0 1 -1.750001,-1.04882801 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-5-3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -20.241535,-1.9228821 a 2.25,1.75 0 0 0 2.25,1.75000001 2.25,1.75 0 0 0 0.800781,-0.1171875 v -0.703125 a 1.75,1.05 0 0 1 -0.800781,0.1191407 1.75,1.05 0 0 1 -1.75,-1.04882821 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-0-9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 20.33982,-8.7822995 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-6-0",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -27.237127,2.6607053 a 1.75,1.05 0 0 1 -1.750001,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.250001,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-3-8",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -23.237128,2.6607053 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.249999,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.749999,1.048828 1.75,1.05 0 0 1 -1.749999,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-9-8",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -27.237127,2.6607053 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-4-5",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -19.237629,2.6611023 a 2.25,1.75 0 0 0 2.046875,1.734375 v -0.699219 a 1.75,1.05 0 0 1 -1.546875,-1.035156 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-8-0",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 22.870846,9.9130075 a 2.25,1.75 0 0 0 2.25,1.7499995 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.0488275 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-7-1-9",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -27.240362,2.0767273 a 1.75,1.05 0 0 1 -1.750001,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.250001,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-8-2-6",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -23.240363,2.0767273 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.249999,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.749999,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-4-9-3",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -27.240362,2.0767273 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-5-3-8",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -19.241535,2.0771179 a 2.25,1.75 0 0 0 2.050781,1.7343754 V 3.1122742 a 1.75,1.05 0 0 1 -1.550781,-1.0351563 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-0-9-5",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 22.867611,9.3290295 a 2.25,1.75 0 0 0 2.25,1.7499995 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.0488275 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-6-0-6",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -26.237127,6.6607053 a 1.75,1.05 0 0 1 -1.750001,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.250001,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-3-8-1",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -22.237128,6.6607053 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.249999,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.749999,1.048828 1.75,1.05 0 0 1 -1.749999,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-9-8-1",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -26.237127,6.6607053 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-4-5-5",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m -18.237629,6.6611023 a 2.25,1.75 0 0 0 1.046875,1.474609 v -0.722656 a 1.75,1.05 0 0 1 -0.546875,-0.751953 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-8-0-9",
    style: {
      display: "inline",
      fill: "#000000",
      strokeWidth: 1.37266
    },
    d: "m 24.447353,14.13088 a 2.25,1.75 0 0 0 2.25,1.75 v -0.701172 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-2-1-7-1-9-8",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -26.240362,6.0767273 a 1.75,1.05 0 0 1 -1.750001,1.048828 v 0.701172 a 2.25,1.75 0 0 0 2.250001,-1.75 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-2-8-2-6-4",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -22.240363,6.0767273 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.249999,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.749999,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-8-93-4-9-3-8",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -26.240362,6.0767273 a 2.25,1.75 0 0 0 2.25,1.75 2.25,1.75 0 0 0 2.25,-1.75 h -0.5 a 1.75,1.05 0 0 1 -1.75,1.048828 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-6-6-7-1-5-3-8-1",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m -18.241535,6.0771183 a 2.25,1.75 0 0 0 1.050781,1.476562 v -0.722656 a 1.75,1.05 0 0 1 -0.550781,-0.753906 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161-3-22-1-6-3-2-0-1-4-0-9-5-0",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.37266
    },
    d: "m 24.444118,13.546902 a 2.25,1.75 0 0 0 2.25,1.75 V 14.59573 a 1.75,1.05 0 0 1 -1.75,-1.048828 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer3"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.0261847
    },
    id: "rect7961",
    width: 21,
    height: 0.30000001,
    x: -17.467604,
    y: -11.441504
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path17458",
    cx: -3.7645836,
    cy: 45.778412,
    rx: 7.5230355,
    ry: 7.0528927
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0.4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path17458-7",
    cx: 25.188391,
    cy: 45.472931,
    rx: 7.5230355,
    ry: 7.0528927
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8164",
    style: {
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.0504782
    },
    d: "M 45.199219,22.306641 A 8,3 0 0 1 38,24 8,3 0 0 1 30.800781,22.298828 v 2.160156 A 10,5 0 0 0 38,26 10,5 0 0 0 45.199219,24.466797 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8164-3",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.0575529
    },
    d: "m 20.072569,44.257227 a 10.399575,3 0 0 1 -9.358603,1.693359 10.399575,3 0 0 1 -9.3586011,-1.701172 v 2.160156 a 12.999468,5 0 0 0 9.3586011,1.541016 12.999468,5 0 0 0 9.358603,-1.533203 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14812",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.0504782
    },
    d: "m 45.199219,22.306641 v 2.160156 A 10,5 0 0 0 48,21 h -2 a 8,3 0 0 1 -0.800781,1.306641 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14807",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.0504782
    },
    d: "m 28,21 a 10,5 0 0 0 2.800781,3.458984 V 22.298828 A 8,3 0 0 1 30,21 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8164-4",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.0504782
    },
    d: "m 29.024346,-5.48666 a 10,5 0 0 0 10,5.00000001 10,5 0 0 0 10,-5.00000001 h -2 a 8,3 0 0 1 -8,3 8,3 0 0 1 -8,-3 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.0504782
    },
    id: "path8164-7",
    cx: 33.822838,
    cy: -23.330072,
    rx: 10,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#1bb233",
      fillOpacity: 1,
      strokeWidth: 0.0583697
    },
    id: "path8166-4",
    cx: 33.822838,
    cy: -23.330072,
    rx: 8,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.052
    },
    id: "path6066-4-7",
    d: "M 29.334951,7.4375911 21.020892,7.3697495 25.236674,0.20348412 Z",
    transform: "matrix(0.47584878,-0.00786752,0.00362702,0.97209556,-2.2331299,28.820952)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.0414283
    },
    id: "rect5961-9-1",
    width: 7,
    height: 7,
    x: 2.7963662,
    y: 28.820208,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#1bb233",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect25140-1",
    width: 7.3600001,
    height: 11.935946,
    x: 1.3862519,
    y: 27.110903,
    rx: 10.5,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect5961-9-3-0-4",
    style: {
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0.101478
    },
    d: "M 26.331067,-2.2434954 V 9.7565049 h 7 V -2.2434954 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#cd0000",
      fillOpacity: 1,
      strokeWidth: 0.052
    },
    id: "path6066-4-3-7-5",
    d: "M 29.334951,7.4375911 21.020892,7.3697495 25.236674,0.20348412 Z",
    transform: "matrix(0.58424414,-0.01236325,0.00445323,1.5275787,-27.986647,5.7924711)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDam);
export default __webpack_public_path__ + "static/media/dam.562a63ae7f07d08751de738664f54fdf.svg";
export { ForwardRef as ReactComponent };